var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-content" },
    [
      _c("radio-button-row", {
        attrs: {
          title: "ContinuousReport.TargetGroupsAndOperation.IsOrganisation",
          required: true,
          componentIndex: _vm.index
        },
        model: {
          value: _vm.targetGroup.isOrganisation,
          callback: function($$v) {
            _vm.$set(_vm.targetGroup, "isOrganisation", $$v)
          },
          expression: "targetGroup.isOrganisation"
        }
      }),
      _vm._v(" "),
      _c("target-group-and-operation-table", {
        attrs: {
          title:
            "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.Title",
          items: _vm.tableItems,
          targets: _vm.targets,
          tableIndex: _vm.index
        }
      }),
      _vm._v(" "),
      _vm.councelingSelected
        ? _c("text-area-row", {
            attrs: {
              title:
                "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.CouncelingDescription",
              id: "councelingdescription-" + _vm.index,
              required: true,
              maxLength: 500,
              rows: 7
            },
            model: {
              value: _vm.targetGroup.councelingDescription,
              callback: function($$v) {
                _vm.$set(_vm.targetGroup, "councelingDescription", $$v)
              },
              expression: "targetGroup.councelingDescription"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.distributionItems, function(item, distributionIndex) {
        return _c(
          "div",
          [
            _c("hr", { staticClass: "mb-2" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row form-group mb-0" },
              [
                _c("div", { staticClass: "col-12 mb-2" }, [
                  _c(
                    "h4",
                    {
                      staticStyle: { all: "unset" },
                      attrs: {
                        id:
                          "distributionName_" +
                          _vm.index +
                          "_" +
                          distributionIndex
                      }
                    },
                    [
                      _c("b", [_vm._v(_vm._s(item.description))]),
                      _vm._v(" "),
                      !item.description
                        ? _c("span", { staticClass: "sr-only" }, [
                            _vm._v(_vm._s(_vm.index))
                          ])
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("plain-text-control", {
                  staticClass: "button-sized-text-in-column col-5",
                  attrs: {
                    id:
                      "agegenderdistributiontable_" +
                      _vm.index +
                      "_" +
                      distributionIndex,
                    title:
                      "ContinuousReport.TargetGroupsAndOperation.Distribution.DistributionHeading"
                  }
                }),
                _vm._v(" "),
                !_vm.isReadOnly
                  ? _c("div", { staticClass: "col-7" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary float-right mb-2",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.clearDistributionData(item)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "ContinuousReport.TargetGroupsAndOperation.TargetsAndOperations.DeleteDistribution"
                              )
                            )
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("age-gender-distribution-table", {
              attrs: {
                title: "AgeGenderDistribution_",
                labelledBy:
                  "distributionName_" +
                  _vm.index +
                  "_" +
                  distributionIndex +
                  " " +
                  "agegenderdistributiontable_" +
                  _vm.index +
                  "_" +
                  distributionIndex,
                distribution: item.ageGenderDistribution,
                componentIndex: _vm.index,
                tableIndex: distributionIndex
              }
            }),
            _vm._v(" "),
            _c("radio-button-option-row", {
              attrs: {
                title:
                  "ContinuousReport.TargetGroupsAndOperation.Distribution.PeopleTurnover",
                required: true,
                componentIndex: _vm.index,
                secondaryIndex: distributionIndex,
                options: _vm.optionsArray("PeopleTurnoverOptions", true)
              },
              model: {
                value: item.peopleTurnover,
                callback: function($$v) {
                  _vm.$set(item, "peopleTurnover", $$v)
                },
                expression: "item.peopleTurnover"
              }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }